import { useEffect, Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { addProject, updateProject } from '../api/api';
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary
import ProjectManager from './Dropdowns/ProjectManagers'
import ClientManager from './Dropdowns/ClientManager'
import { formatedDate } from '../api/services'
import {toast} from 'react-toastify'
export default function AddProject({
  addModalSetting,
  handlePageUpdate,
  authContext,
  data,
  isEditing,
  setEditing,
}) {
  const { theme } = useTheme(); // Get the theme from context
  const [pmanager, setPmanager] = useState('')
  const [cmanager, setCmanager] = useState('')
  const [project, setProject] = useState({
    project_name: "",
    description: "",
    project_duration: "",
    project_manager:"",
    client_side_manager:"",
    project_budget: "",
    start_date: '',
    end_date: '',
    actual_end_date: '',
    location: '',
    cost: "",
  });
  const [status, setStatus] = useState('Started')
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  }

  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({});
  const cancelButtonRef = useRef(null);

  // Calculate minimum dates for validation (next day after start date)
  const getMinEndDate = () => {
    if (!project.start_date) return '';
    const start = new Date(project.start_date);
    start.setDate(start.getDate() + 1); // Add 1 day
    return start.toISOString().split('T')[0];
  };

  const getMinActualEndDate = () => {
    if (!project.end_date) return '';
    const end = new Date(project.end_date);
    end.setDate(end.getDate() + 1); // Add 1 day
    return end.toISOString().split('T')[0];
  };

  // Check if field is disabled
  const isEndDateDisabled = !project.start_date;
  const isActualEndDateDisabled = !project.end_date;

  useEffect(() => {
    // Set default start date to today if not editing
    if (!isEditing && !project.start_date) {
      const today = new Date().toISOString().split('T')[0];
      setProject(prev => ({ ...prev, start_date: today }));
    }
    
    if (data && isEditing) {
      setProject({
        project_name: data.project_name,
        description: data.description,
        project_duration: data.project_duration,
        cost: data.cost,
        project_budget: data.project_budget,
        start_date: formatedDate(data.start_date),
        end_date: formatedDate(data.end_date),
        actual_end_date: formatedDate(data.actual_end_date),
        location: data.location,

      });
      setPmanager(data.project_manager)
      setCmanager(data.client_side_manager)
      setStatus(data.status)
    }
  }, [data, isEditing]);
  // console.log(project)
  const handleInputChange = (key, value) => {
    setProject({ ...project, [key]: value });
  };


  const AddProject = async () => {
    const { project_name, description, project_duration } = project;

    // Validate required fields
    if (!project_name || !description || !project_duration) {
      toast.error("Please fill in all fields.");
      return;
    }

    // Validate dates
    const validationErrors = {};
    
    if (project.start_date && project.end_date) {
      if (new Date(project.start_date) >= new Date(project.end_date)) {
        validationErrors.end_date = "End date must be after start date";
      }
    }
    
    if (project.end_date && project.actual_end_date) {
      if (new Date(project.end_date) >= new Date(project.actual_end_date)) {
        validationErrors.actual_end_date = "Actual end date must be after end date";
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const formData = {
      project_name: project.project_name,
      description: project.description,
      project_duration: project.project_duration,
      project_manager: project.project_manager,
      client_side_manager: project.client_side_manager,
      cost: project.cost,
      start_date: project.start_date,
      end_date: project.end_date,
      status: status,
      actual_end_date: project.actual_end_date,
      location: project.location,
      project_budget: project.project_budget,

    }
    setLoading(true);
    try {
      if (data && isEditing) {
        const id = data._id;
        const response = await updateProject({ id, data: formData });
        if (response.data) {
          setOpen(false);
          setEditing(false)
          handlePageUpdate()
          toast.success("Project updated successfully!");

        }
      } else {
        const res = await addProject(formData);
        if (res.data) {
          addModalSetting();
          handlePageUpdate();
          resetForm();
          setOpen(false);
          toast.success("Project added successfully!");

        }

      }
    } catch (error) {
      if (error.response) {
        console.error("Failed to add project: " + error.response.data.message || "Internal Server Error");
      }
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setProject({
      project_name: "",
      description: "",
      project_duration: "",
      cost: "",

    });
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={`relative transform overflow-hidden rounded-lg ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'} shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl`}>
                <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} px-6 pt-5 pb-4 sm:p-6 sm:pb-4`}>
                  <div className="sm:flex sm:items-start">

                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title as="h3" className="text-3xl leading-6 font-semibold text-center">
                        {isEditing ? 'Edit Project' : 'Add Project'}
                      </Dialog.Title>
                      <form action="#" className="mt-5 grid gap-6 sm:grid-cols-4">
                        <div>
                          <label htmlFor="project_name" className="block text-sm font-medium">
                            Project Name
                          </label>
                          <input
                            type="text"
                            name="project_name"
                            id="project_name"
                            value={project.project_name}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project name"
                          />
                        </div>
                        

                        <div>
                          <label htmlFor="project_duration" className="block text-sm font-medium">
                            Project Duration
                          </label>
                          <input
                            type="text"
                            name="project_duration"
                            id="project_duration"
                            value={project.project_duration}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project duration"
                          />
                        </div>
                        <div>
                          <label htmlFor="project_duration" className="block text-sm font-medium">
                            Project Manager
                          </label>
                          <input
                            type="text"
                            name="project_manager"
                            id="project_manager"
                            value={project.project_manager}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project manager.."
                          />
                        </div>
                        <div>
                          <label htmlFor="project_duration" className="block text-sm font-medium">
                            Client Manager
                          </label>
                          <input
                            type="text"
                            name="client_side_manager"
                            id="client_side_manager"
                            value={project.client_side_manager}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter client manager.."
                          />
                        </div>
                        <div>
                          <label htmlFor="project_budget" className="block text-sm font-medium">
                            Project Budget
                          </label>
                          <input
                            type="text"
                            name="project_budget"
                            id="project_budget"
                            value={project.project_budget}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project budget"
                          />
                        </div>
                        <div>
                          <label htmlFor="start_date" className="block text-sm font-medium">
                            Start Date
                          </label>
                          <input
                            type="date"
                            name="start_date"
                            id="start_date"
                            value={project.start_date}
                            onClick={(e)=>e.target.showPicker()}
                            onChange={(e) => {
                              handleInputChange(e.target.name, e.target.value);
                              setErrors({ ...errors, end_date: null, actual_end_date: null });
                            }}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project name"
                          />
                        </div>
                        <div>
                          <label htmlFor="end_date" className="block text-sm font-medium">
                            End Date
                          </label>
                          <input
                            type="date"
                            name="end_date"
                            id="end_date"
                            value={project.end_date}
                            min={getMinEndDate()}
                            disabled={isEndDateDisabled}
                            onClick={(e)=>e.target.showPicker()}
                            onChange={(e) => {
                              handleInputChange(e.target.name, e.target.value);
                              setErrors({ ...errors, end_date: null });
                            }}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''} ${errors.end_date ? 'border-red-500' : ''} ${isEndDateDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                            placeholder="Select start date first"
                          />
                          {isEndDateDisabled && <p className="text-gray-500 text-xs mt-1">Select start date first</p>}
                          {errors.end_date && <p className="text-red-500 text-xs mt-1">{errors.end_date}</p>}
                        </div>
                        <div>
                          <label htmlFor="actual_end_date" className="block text-sm font-medium">
                            Actual End Date
                          </label>
                          <input
                            type="date"
                            name="actual_end_date"
                            id="actual_end_date"
                            min={getMinActualEndDate()}
                            disabled={isActualEndDateDisabled}
                            onClick={(e)=>e.target.showPicker()}
                            value={project.actual_end_date}
                            onChange={(e) => {
                              handleInputChange(e.target.name, e.target.value);
                              setErrors({ ...errors, actual_end_date: null });
                            }}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''} ${errors.actual_end_date ? 'border-red-500' : ''} ${isActualEndDateDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                            placeholder="Select end date first"
                          />
                          {isActualEndDateDisabled && <p className="text-gray-500 text-xs mt-1">Select end date first</p>}
                          {errors.actual_end_date && <p className="text-red-500 text-xs mt-1">{errors.actual_end_date}</p>}
                        </div>
                        <div>
                          <label htmlFor="cost" className="block text-sm font-medium">
                            Project Cost
                          </label>
                          <input
                            type="text"
                            name="cost"
                            id="cost"
                            value={project.cost}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project cost"
                          />
                        </div>
                        <div>
                          <label htmlFor="location" className="block text-sm font-medium">
                            Location
                          </label>
                          <input
                            type="text"
                            name="location"
                            id="location"
                            value={project.location}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project location"
                          />
                        </div>
                        <div>
                          <label htmlFor="status" className="block text-sm font-medium">
                            Status
                          </label>
                          <select
                            id="status"
                            name="status"
                            value={status}
                            onChange={handleStatusChange}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}>
                            <option value="Started">Started</option>
                            <option value="Phase 1">Phase 1</option>
                            <option value="Phase 2">Phase 2</option>
                            <option value="Phase 3">Phase 3</option>
                            <option value="Completed">Completed</option>

                          </select>

                        </div>

                        <div className="col-span-4">
                          <label htmlFor="description" className="block text-sm font-medium">
                            Description
                          </label>
                          <textarea
                            name="description"
                            id="description"
                            rows="4"
                            value={project.description}
                            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            className={`mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            placeholder="Enter project description"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="justify-between px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    onClick={AddProject}
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                    disabled={loading}
                  >
                    {loading ? 'Saving...' : isEditing ? 'Save Changes' : 'Add Project'}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
